import { AppRoute } from '@agentselly/immodossier-shared';
import { useLoaderQuery } from '~/helper/useLoaderQuery';

/** V3_REDESIGN flag from the (cached) root loader; false until loaded. */
export function useV3Redesign(): boolean {
  const query = useLoaderQuery(AppRoute.ROOT, {
    currentRoute: location.pathname,
    params: {},
  });
  return Boolean(query.data?.v3Redesign);
}
